import { Metadata } from 'aws-sdk/clients/s3';

export enum MediaSize {
  source = 'source',
  origin = 'origin',
  small = 'small',
  medium = 'medium',
  large = 'large',
}

export enum UploadMediaPayloadKeys {
  fileId = 'fileId',
  filePath = 'filePath',
  mediaData = 'mediaData',
  metadata = 'metadata',
  contentType = 'contentType',
  withThumbnail = 'withThumbnail',
}

export enum DeleteMediaPayloadKeys {
  filePath = 'filePath',
}

export enum GetFileUploadUrlResponseKeys {
  uploadUrl = 'uploadUrl',
  key = 'key',
  requiredHeaders = 'requiredHeaders',
}

export interface UploadMediaPayload {
  [UploadMediaPayloadKeys.fileId]?: string;
  [UploadMediaPayloadKeys.filePath]: string;
  [UploadMediaPayloadKeys.withThumbnail]?: boolean;
  [UploadMediaPayloadKeys.mediaData]: string;
  [UploadMediaPayloadKeys.contentType]: string;
  [UploadMediaPayloadKeys.metadata]?: Metadata;
}
export interface UploadFilePayload {
  [UploadMediaPayloadKeys.fileId]?: string;
  [UploadMediaPayloadKeys.filePath]: string;
  [UploadMediaPayloadKeys.mediaData]: string;
  [UploadMediaPayloadKeys.contentType]: string;
  [UploadMediaPayloadKeys.metadata]?: Metadata;
}

export interface GetFileUploadUrlPayload {
  [UploadMediaPayloadKeys.fileId]: string;
  [UploadMediaPayloadKeys.filePath]: string;
  [UploadMediaPayloadKeys.contentType]: string;
  [UploadMediaPayloadKeys.metadata]?: Metadata;
}

export interface GetFileUploadUrlResponse {
  [GetFileUploadUrlResponseKeys.uploadUrl]: string;
  [GetFileUploadUrlResponseKeys.key]: string;
  [GetFileUploadUrlResponseKeys.requiredHeaders]?: Record<string, string>;
}

export interface DeleteMediaPayload {
  [DeleteMediaPayloadKeys.filePath]: string;
}
